import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import './index.css';
import '../node_modules/normalize.css/normalize.css';

import App from './components/App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(
  <IntlProvider locale="en">
    <App />
  </IntlProvider>, document.getElementById('root'));
unregister();

if (window.caches) {
  caches.keys().then((names) => {
    for (let name of names) caches.delete(name);
  });
}
